import * as React from 'react'
import Link from 'next/link'

import * as plume from '@ulule/owl-kit-components/next'

import * as url from '@boutique/url'

export function Breadcrumbs(): React.ReactElement {
  return (
    <plume.Breadcrumbs
      LinkComponent={({ href, children }) => <Link href={href}>{children}</Link>}
      crumbs={url.giftIdeas().crumbs}
    />
  )
}
